import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import validator from "validator";
import LoginBg from "./../images/login-bg.jpg";
import Logo from "./../images/sustain-change-logo.png";
import LogoIcon from "./../images/logo-icon.png";
import configVars from "../config";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {

    const [userEmail, setUserEmail] = useState('');
    const [isError, setIsError] = useState(false);
	const [isSuccess, setIsSuccess] = useState( false );
	const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
	const [step, setStep] = useState('request');
	const [newPass, setNewPass] = useState('');
	const [confirmPass, setConfirmPass] = useState('');
	const [authCode, setAuthCode] = useState('');
	const [processing, setProcessing] = useState(false);
	const [redirectToLogin, setRedirectToLogin] = useState(false);
	const [cookies, removeCookie] = useCookies([ "sustainyou_user_jwt"]);
	const [translation] = useTranslation("translations");
	//const [resetSuccess, setResetSuccess] = useState(false);

	const rotatingSpinner = <div className="spinner-border spinner-border-sm me-2" role="status">
								<span className="visually-hidden">Loading...</span>
							</div>;

    useEffect(() => {

		const queryString = window.location.search;
		const urlParams = new URLSearchParams( queryString );

		if ( urlParams.get('auth') ) {
			const auth = urlParams.get('auth');
			
			if ( auth ) {
				setStep( 'reset' );
				setAuthCode( auth );
			}
		}
  
    }, []);

    const sendRequest = async ( item, step ) => {

        if ( ! item ) return;
		if ( ! step ) return;

		let responseUrl;

		if ( step === 'request' ) {
			responseUrl = `${configVars.apiUrl}sustainchange/v1/passwordreset/?user_email=${item}&step=request`;
		} else if ( step === 'reset' ) {
			responseUrl = `${configVars.apiUrl}sustainchange/v1/passwordreset/?authcode=${item}&step=reset&pass=${encodeURIComponent(newPass)}`;
		}

        const response = await fetch(
            responseUrl,
            {
              method: "GET",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
              },
            }
        );

        const passResponse = await response.json();

        return passResponse;

    }

    const handleRequest = () => {

        setIsError(false);
        setErrorMsg("");

		setProcessing(true);

		if (cookies.sustainyou_user_jwt) {
			removeCookie("sustainyou_user_jwt", { path: "/" });
			removeCookie("sustainyou_jwt_issued", { path: "/" });
			removeCookie("sustainyou_jwt_expire", { path: "/" });
		}

        if ( ! userEmail.toString().trim().length ) {
            setIsError(true);
            setErrorMsg( translation("enter_email") );
            return;
        }
        
        if ( ! validator.isEmail( userEmail ) ) {
            setIsError(true);
            setErrorMsg( translation("enter_valid_email") );
      
            return;
        }

        sendRequest( userEmail, 'request' ).then( (response) => {

			if ( response.success && response.success === true ) {

				setIsSuccess(true);
				setSuccessMsg( translation("check_confirmation") );

			} else {

				setIsError(true);
				setErrorMsg( response.message );

			}

            //console.log( response );

			setProcessing( false );
        });
    }

	const handleReset = () => {

		if ( !authCode ) return;
		
		setIsError(false);
        setErrorMsg("");

		if ( ! newPass.toString().trim().length || ! confirmPass.toString().trim().length ) {
            setIsError(true);
            setErrorMsg( translation("pswd_not_empty") );
            return;
        }

		if ( newPass !== confirmPass ) {
			setIsError(true);
            setErrorMsg( translation("pswd_not_match") );
            return;
		}

		if ( newPass.length < 8 ) {
			setIsError(true);
			setErrorMsg( translation("pswd_char_limit") );

			return;
		}

		if ( ! validator.isStrongPassword( newPass, { minLength: 8, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1}) ) {
			setIsError(true);
			setErrorMsg( translation("pswd_limit") );

			return;
		}

		setProcessing(true);


		sendRequest( authCode, 'reset' ).then( (response) => {

			if ( response.success && response.success === true ) {

				setIsSuccess(true);
				setSuccessMsg( translation("login_success") );

				setTimeout(() => { setRedirectToLogin(true) }, 3000);

			} else {

				setIsError(true);
				setErrorMsg( response.message );

			}
            //console.log( response );

			setProcessing(false);
        });

	}

	if (redirectToLogin) {
		return <Redirect to="/login/" />;
	  }
	
    
    return (
        <div className="login-wrap min-vh-100 min-vw-100 d-flex align-items-center" style={{ backgroundImage: `url(${LoginBg})`}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-5">
              <div className="d-flex flex-column align-items-center px-4 py-4 py-lg-6 h-100 justify-content-center border border-1 shadow bg-white">
			  <div className="mb-4 d-flex flex-column justify-content-center align-items-center">
              <img
                  src={LogoIcon}
                  className="img-fluid mb-3"
                  style={{ maxWidth: "100px" }}
                  alt="Login"
                />
                <img
                  src={Logo}
                  className="img-fluid"
                  style={{ maxWidth: "200px" }}
                  alt="Login"
                />
              </div>
  
                {isError && (
                  <div className="mt-3 w-100">
                    <div className="alert alert-secondary rounded-0" role="alert">
                      {errorMsg}
                    </div>
                  </div>
                )}

				{isSuccess && (
                  <div className="mt-3 w-100">
                    <div className="alert alert-success rounded-0" role="alert">
                      {successMsg}
                    </div>
                  </div>
                )}

				{ step === 'request' &&
					<>
						<div className="my-3 w-100">
							<input type="email" className={`form-control rounded-0`} id="user_email" value={userEmail} placeholder={translation("enter_email")} onChange={ (e) => setUserEmail(e.target.value)} />
						</div>

						<button type="submit" className="btn btn-primary text-white px-lg-6 rounded-0 w-100" onClick={() => handleRequest()}>
							{ processing &&
								rotatingSpinner
							}
							<span>{translation("request_pswd_reset")}</span>
						</button>
					</>
				}

				{ step === 'reset' &&
					<>
						<div className="mb-3 w-100">
							<input type="password" className={`form-control rounded-0`} id="new_password" value={newPass} placeholder={translation("enter_new_pswd")} onChange={ (e) => setNewPass(e.target.value)} />
						</div>
						<div className="mb-3 w-100">
							<input type="password" className={`form-control rounded-0`} id="confirm_password" value={confirmPass} placeholder={translation("confirm_pswd")} onChange={ (e) => setConfirmPass(e.target.value)} />
						</div>

						<button type="submit" className="btn btn-primary text-white px-lg-6 rounded-0 w-100" onClick={() => handleReset()}>
							{ processing &&
								rotatingSpinner
							}
							<span>{translation("reset_pswd")}</span>
						</button>
					</>
				}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default ResetPassword;